import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from 'ngx-libs-http';
import { Faucets } from '../api/main/faucets';
import { Markets } from '../api/main/markets';
import { Accounts } from '../api/main/accounts';
import { Ips } from '../api/main/ips';
import { PointLeaderboards } from '../api/main/point-leaderboards';
import { Announcements } from '../api/main/announcements';
import { TradingVaults } from '../api/main/trading-vaults';
import { Beta } from '../api/main/beta';
import { SystemConfig } from '../api/main/system-config';
import BigNumber from 'bignumber.js';
import { Observable, of, timer } from 'rxjs';
import { map, mergeMap, tap } from 'rxjs/operators';
import { sharePublishReplay, swalloError } from 'ngx-libs';
import { Campaigns } from '../api/main/campaigns';

@Injectable({
  providedIn: 'root'
})
export class MainService {
  httpClient: HttpClient;
  // unauthorized: Observable<any>;
  markets: Markets;
  accounts: Accounts;
  faucets: Faucets;
  ips: Ips;
  pointLeaderboards: PointLeaderboards;
  announcements: Announcements;
  tradingVaults: TradingVaults;
  systemConfig: SystemConfig;
  campaigns: Campaigns;
  beta: Beta;

  pointPrice: Observable<BigNumber>;
  appliedPointPrice: Observable<BigNumber>;
  rate: Observable<BigNumber>;

  constructor(private httpService: HttpService) {
    this.httpClient = this.httpService.get('main');
    // this.unauthorized = this.httpService.unauthorized('main');
    this.markets = new Markets(this.httpClient);
    this.accounts = new Accounts(this.httpClient);
    this.faucets = new Faucets(this.httpClient);
    this.ips = new Ips(this.httpClient);
    this.pointLeaderboards = new PointLeaderboards(this.httpClient);
    this.announcements = new Announcements(this.httpClient);
    this.tradingVaults = new TradingVaults(this.httpClient);
    this.systemConfig = new SystemConfig(this.httpClient);
    this.campaigns = new Campaigns(this.httpClient);
    this.beta = new Beta(this.httpClient);

    const systemConfig = timer(0, 60000).pipe(
      mergeMap(() => this.systemConfig.query().pipe(swalloError())),
      map((json) => this.processSystemConfig(json.systemConfig)),
      sharePublishReplay(1)
    );

    this.pointPrice = systemConfig.pipe(
      map((record) => record.pointPrice)
    );

    this.appliedPointPrice = systemConfig.pipe(
      map((record) => record.appliedPointPrice)
    );

    this.rate = systemConfig.pipe(
      map((record) => record.rate)
    );
  }

  private processSystemConfig(record: any) {
    record.pointPrice = new BigNumber(record.pointPrice);
    record.appliedPointPrice = new BigNumber(record.appliedPointPrice);
    record.rate = record.pointPrice.div(record.appliedPointPrice);
    return record;
  }
}
